export default __webpack_public_path__ + "static/media/927E4EA0-BD69-4127-98BC-76E9A1831F9B.867d0fb2.jpg";